var validate = {
    init: function() {
        $('.required').each(function() {
            var $this = $(this);

            if ($this.hasClass('no-blur')) {
                return false;
            }

            $this.bind('blur', function() {
                validate.validate($this);
            });
        });
    },
    validate: function(handler) {
        var validationType = handler.data('validation'),
            val = handler.val(),
            error = true,
            errorHandler = $('.error-message'),
            errorMessage = '';

        switch (validationType) {
            case 'email':
                if (val.length > 0) {
                    var match = /^\s?[\d\w!\.\-]*@[\d\w]+[\d\w\-]*(\.[\d\w\-]+)*\.[\w]{2,7}\s?(\,\s?[\d\w!\.\-]*@[\d\w]+[\d\w\-]*(\.[\d\w\-]+)*\.[\w]{2,7}\s?){0,4}$/;
                    error = match.test(val) === false;
                    errorMessage = handler.data('wrong-format');

                } else {
                    errorMessage = handler.data('error-message');
                }

                break;
            case 'confirm':
                if (val.length > 0) {
                    var confirmMatch = /^\s?[\d\w!\.\-]*@[\d\w]+[\d\w\-]*(\.[\d\w\-]+)*\.[\w]{2,7}\s?(\,\s?[\d\w!\.\-]*@[\d\w]+[\d\w\-]*(\.[\d\w\-]+)*\.[\w]{2,7}\s?){0,4}$/;
                    error = confirmMatch.test(val) === false;
                    errorMessage = handler.data('wrong-format');

                    if (error === false) {
                        if ($('#driverEmail').val() !== handler.val()) {
                            error = true;
                            errorMessage = handler.data('confirm-message');
                        }
                    }

                } else {
                    errorMessage = handler.data('error-message');
                }
                break;
            case 'phone':
                if (val.length > 0) {
                    var phoneMatch = /^[0-9\Q\-\+\E]+$/;
                    error = phoneMatch.test(val) === false;
                    errorMessage = handler.data('wrong-format');

                } else {
                    errorMessage = handler.data('error-message');
                }

                break;
            case 'select':
                if (val !== '0') {
                    error = false;
                } else {
                    errorMessage = handler.data('error-message');
                }
                break;
            case 'onlyLatin':
                if (val.length > 0) {
                    var latinMatch = /^[a-zA-Z\.\'\-\s]+$/;

                    error = latinMatch.test(val.trim()) === false;
                    errorMessage = handler.data('wrong-input');

                } else {
                    errorMessage = handler.data('error-message');
                }
                break;
            default:
                if (val.length > 0) {
                    error = false;
                } else {
                    errorMessage = handler.data('error-message');
                }
                break;
        }

        if (error) {
            handler.addClass('error');
            errorHandler.empty().append('<p>' + errorMessage + '</p>').addClass('show');
        } else {
            handler.removeClass('error');
            errorHandler.slideUp();
        }
    }
};
